<template>
  <a class="goTop">
    <i class="fa fa-angle-up" />
  </a>
</template>

<script>
/* global $ */
export default {
  mounted() {
    // eslint-disable-next-line no-undef
    $(window).on('scroll resize', () => {
      const headerHeight = $(window).width() > 991 ? 70 : 60;
      const windowTop = $(window).scrollTop();

      if ($('.goTop').length) {
        if (windowTop < headerHeight) {
          $('.goTop').fadeOut();
        }

        if (windowTop >= headerHeight) {
          $('.goTop').fadeIn();
        }
      }
    });

    $('.goTop').click(() => {
      $('html,body').animate(
        { scrollTop: 0 },
        'slow',
      );
    });
  },
};
</script>

<style lang="scss" scoped>
.goTop {
  position: fixed;
  z-index: 90;
  right: 30px;
  bottom: 120px;
  display: none;
  width: 50px;
  height: 50px;
  color:#fff;
  text-align: center;
  line-height: 50px;
  background: var(--primary-color);
  border-radius: 50%;
  box-shadow: 0 2px 5px 0 rgba(#000, .1);
  transition: all 0.5s;

  &:hover{
    background-color: var(--primary-color);
  }
}
</style>
